import { PartialId } from '@attain-apps/string-builder'

import * as core from '../../../../../../../../core'
import * as results from '../../results'

export const RESOURCE = {
  payload: {
    description:
      'The latest test and deployment result for one implementation pull request, covering every requirement that pull request closes. CI fills the test result when tests finish and deployment fills the deploy result after merge; reruns overwrite the same row.',
    dimension: results.RESOURCE.payload,
    level: 0,
    name: 'Result',
    partialId: PartialId.Standard.create('result'),
  },
  type: core.quiver.Resource.Type.DmsEntity,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsEntity>

export const MODEL_ID = core.dms.models.Entity.Id.from({
  context: core.dms.models.Entity.Id.Context.from(RESOURCE.payload.dimension),
  partialId: RESOURCE.payload.partialId,
})
